class ObjectId {
  constructor(id) {
    this.id = id || Math.random().toString(16).slice(2);
  }
  toString() {
    return this.id;
  }
  toHexString() {
    return this.id;
  }
}

export const Types = {
  ObjectId,
};

export const Schema = () => {};
export const model = () => {};
export const connect = () => {};
export const connection = {};
export default { Types, Schema, model, connect, connection };
